import OverTime from "../../../src/visualization/connectedCharts/ConnectedOvertime";
import { buildMeta } from "../../routeMeta";

export function meta(args) {
  return buildMeta(
    {
      title: "Over Time — The Atlas of Economic Complexity",
      description:
        "Track how a country's exports or imports have evolved over time.",
      ogImage: "share_stack.png",
    },
    args,
  );
}

export default function OverTimeRoute() {
  return <OverTime />;
}
